<div class="modal-container">
  <mat-dialog-content class="mat-typography">
    <div class="main-container">
      <div class="header d-flex">
        <h2 mat-dialog-title class="page-title">Provide additional feedback</h2>
        <div class="d-flex justify-content-end modalCancel">
          <button class="modalCancelBtn" [mat-dialog-close]="false" align="end">
            <i class="icon icon-e-remove"></i>
          </button>
        </div>
      </div>
      <div class="modal-container">
        <ng-container>
          <form [formGroup]="reportChatForm" (ngSubmit)="submitReport()">
            <div class="form-group">
              <textarea
                formControlName="narrative"
                class="form-control"
                name="contentInput"
                cols="150"
                rows="5"
                placeholder="What was the issue with the response? How could it be improved?"
              >
              </textarea>
              <br />
            </div>
            <div class="d-flex justify-content-center">
              <button
                type="submit"
                class="button -primary customBtn"
                [disabled]="reportChatForm.invalid"
              >
                Submit feedback
              </button>
            </div>
          </form>
        </ng-container>
      </div>
    </div>
  </mat-dialog-content>

  <!-- Copyright 2020 Google LLC. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
</div>
